import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ListAttachmentSummariesResponse,
    TListAttachmentSummariesResponse,
} from "../../types/devices/ttr/listAttachmentSummariesTypes"

type TListAttachmentSummariesMapper = {
    map: (response: unknown) => TListAttachmentSummariesResponse
}

export const listAttachmentSummariesMapper: TListAttachmentSummariesMapper = {
    map: (response: unknown) =>
        tsIoValidate(
            ListAttachmentSummariesResponse,
            response,
            "listAttachmentSummariesMapper"
        ),
}
